function getElementTotalHeight(selector: string): number {
  const element = document.querySelector(selector) as HTMLElement;
  if (!element) return 0;

  const rect = element.getBoundingClientRect();
  const styles = getComputedStyle(element);

  return (
    rect.height +
    (parseFloat(styles.paddingTop) || 0) +
    (parseFloat(styles.paddingBottom) || 0) +
    (parseFloat(styles.marginTop) || 0) +
    (parseFloat(styles.marginBottom) || 0)
  );
}

function getOverlayWrapperSpacing(): number {
  const overlayWrapper = document.querySelector('[class*="overlayWrapper"]') as HTMLElement;
  if (!overlayWrapper) return 0;

  const styles = getComputedStyle(overlayWrapper);
  return (
    (parseFloat(styles.paddingTop) || 0) +
    (parseFloat(styles.paddingBottom) || 0) +
    (parseFloat(styles.marginTop) || 0) +
    (parseFloat(styles.marginBottom) || 0)
  );
}

export function calculateVideoPlayerDimensions(): {
  maxWidth: number;
} {
  let usedHeight = 0;
  const viewportHeight = window.innerHeight;

  usedHeight += getOverlayWrapperSpacing();

  const elementsToMeasure = [
    '[class*="overlayCloseButton"]',
    '[class*="videoTitle"]',
    '[class*="videoDescription"]',
    '[class*="social_share"]',
  ];

  elementsToMeasure.forEach((selector) => {
    usedHeight += getElementTotalHeight(selector);
  });

  const availableHeight = Math.max(viewportHeight - usedHeight, 200);
  const calculatedWidth = (availableHeight * 16) / 9;

  return {
    maxWidth: calculatedWidth,
  };
}

export function calculateImageDimensions(): {
  maxHeight: number;
} {
  let usedHeight = 0;
  const carouselIndicatorHeight = 28;
  const carouselHorizontalSpacing = 48;
  const viewportHeight = window.innerHeight;

  usedHeight += getOverlayWrapperSpacing();

  const elementsToMeasure = ['[class*="overlayCloseButton"]', '[class*="overlayContent"]'];

  elementsToMeasure.forEach((selector, i) => {
    usedHeight += getElementTotalHeight(selector);
  });

  const availableHeight = Math.max(
    viewportHeight - usedHeight - carouselIndicatorHeight - carouselHorizontalSpacing,
    200,
  );

  return {
    maxHeight: availableHeight,
  };
}

function truncateNode(node: Node, remaining: { value: number }): boolean {
  if (node.nodeType === Node.TEXT_NODE) {
    if (remaining.value <= 0) {
      node.textContent = '';
      return false;
    }
    const text = node.textContent || '';
    if (text.length > remaining.value) {
      node.textContent = text.slice(0, remaining.value) + '...';
      remaining.value = 0;
      return false;
    } else {
      remaining.value -= text.length;
    }
  } else if (node.nodeType === Node.ELEMENT_NODE) {
    const children = Array.from(node.childNodes);
    for (const child of children) {
      if (!truncateNode(child, remaining)) {
        let next = child.nextSibling;
        while (next) {
          const toRemove = next;
          next = next.nextSibling;
          node.removeChild(toRemove);
        }
        return false;
      }
    }
  }
  return true;
}

export function truncateHtmlTextNodes(html: string, maxLength = 256): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const remaining = { value: maxLength };

  truncateNode(doc.body, remaining);

  return doc.body.innerHTML;
}
